import React, { Suspense } from "react";
//import { HashRouter } from 'react-router-dom';

import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom";

import { Provider } from "react-redux";
import store from './redux/store'
import { UserContextProvider } from './contexts/userContext';
import "./assets/icons/remixicon.css";
import "./assets/less/yoda-theme.less";

import App from "./App";

ReactDOM.render(
  <UserContextProvider>
    <Suspense fallback="loading">
      <Provider store={store}>
        <BrowserRouter >
          <App />
        </BrowserRouter>
      </Provider>
    </Suspense>
  </UserContextProvider>,
  document.getElementById("root")
);